import { del, get, post } from "../../../core/api/client";
import { API_ENDPOINTS } from "../../../core/api/endpoints";

// Payment methods live in Stripe — the API fetches them from the client's Stripe customer.
export const getPaymentMethods = async (clientId, params = {}) => {
  const { type = "card", limit = 20 } = params;

  const queryString = [
    `type=${encodeURIComponent(type)}`,
    `limit=${encodeURIComponent(limit)}`,
  ].join("&");

  const endpoint = `${API_ENDPOINTS.PAYMENT_METHODS.LIST_BY_CLIENT(clientId)}?${queryString}`;
  return get(endpoint);
};

export const attachPaymentMethod = async (stripePmId, clientId, isDefault = false) => {
  return post(API_ENDPOINTS.PAYMENT_METHODS.ATTACH, {
    client_id: clientId,
    stripe_payment_method_id: stripePmId,
    is_default: isDefault,
  });
};

export const setDefaultPaymentMethod = async (stripePmId, clientId) => {
  return post(API_ENDPOINTS.PAYMENT_METHODS.SET_DEFAULT(stripePmId), {
    client_id: clientId,
  });
};

// Detaches the payment method from the Stripe customer.
export const deletePaymentMethod = async (stripePmId) => {
  return del(API_ENDPOINTS.PAYMENT_METHODS.DELETE(stripePmId));
};
